import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

const DOC_TYPES = ['submittal', 'oandm', 'as_built', 'warranty', 'test_report', 'other'];

export default function OFEDocumentationTracker() {
  const { id: project } = useParams();
  const { user } = useAuth();
  const [typeFilter, setTypeFilter] = useState('');
  const query = [project && `project=${project}`, typeFilter && `doc_type=${typeFilter}`, 'latest_only=true'].filter(Boolean).join('&');
  const { data: docs, loading } = useOFEFetch(`/ofe/cx/documents?${query}`, user, [project, typeFilter]);

  const grouped = (docs || []).reduce((acc, d) => {
    (acc[d.doc_type] = acc[d.doc_type] || []).push(d);
    return acc;
  }, {});

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-4">
        {project && <Link to={`/ofe/projects/${project}`} className="text-gray-400 hover:text-white text-sm">← {project}</Link>}
        <h1 className="text-xl font-bold text-white">Documentation Tracker {project && <span className="text-blue-400 font-mono">— {project}</span>}</h1>
        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)}
          className="ml-auto bg-gray-800 border border-gray-600 text-white px-3 py-1.5 rounded text-sm">
          <option value="">All types</option>
          {DOC_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>

      {loading && <div className="text-gray-400">Loading...</div>}

      {Object.entries(grouped).map(([type, typeDocs]) => (
        <div key={type} className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
          <div className="bg-gray-900 px-4 py-2 text-gray-300 font-semibold text-sm uppercase tracking-wide">
            {type.replace(/_/g, ' ')} ({typeDocs.length})
          </div>
          <table className="w-full text-sm">
            <thead className="text-gray-400 border-b border-gray-700">
              <tr><th className="text-left px-4 py-2">Title</th><th className="text-left px-4 py-2">Version</th><th className="text-left px-4 py-2">Submitted</th><th className="text-left px-4 py-2">Approved</th><th className="text-left px-4 py-2">Link</th></tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {typeDocs.map(d => (
                <tr key={d.id} className="hover:bg-gray-750">
                  <td className="px-4 py-2 text-white">{d.title}</td>
                  <td className="px-4 py-2 text-gray-400 font-mono text-xs">{d.version || '—'}</td>
                  <td className="px-4 py-2 text-gray-300 text-xs">{d.submitted_at || '—'}</td>
                  <td className="px-4 py-2 text-xs">
                    {d.approved_at ? <span className="text-green-400">✓ {d.approved_at}</span> : <span className="text-yellow-400">Pending</span>}
                  </td>
                  <td className="px-4 py-2">
                    {d.sharepoint_url && <a href={d.sharepoint_url} target="_blank" rel="noreferrer" className="text-blue-400 text-xs hover:text-blue-300">SharePoint →</a>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      {!docs?.length && !loading && (
        <div className="text-center py-12 text-gray-500">No documents found</div>
      )}
    </div>
  );
}
